import React from "react";
import { withStyles } from "@material-ui/core";
import Select from "../../../../../common/StyledSelect";
import DriverRecommendationCard from "./DriverRecommendationCard";
import appConstants from "../../../../../../appConstants";
import constants from "../constants";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${theme.AppBGColor}`,
    marginTop: 16,
    marginBottom: 8,
  },
  label: {
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.HeaderSelectedText,
    marginTop: 12,
    marginBottom: 10,
  },
  driverNameLabel: {
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.iconColor,
    marginRight: 10,
  },
  driverNameLabelMargin: {
    marginRight: 16,
  },
  driver: {
    display: "flex",
    marginBottom: 16,
    alignItems: "center",
  },
  driverInfeasibleContainer: {
    alignItems: "center",
  },
  dropdownContainer: {
    display: "flex",
    flex: 1,
    maxWidth: 306,
  },
  noRecommendations: { textAlign: "center" },
  selectRoot: {
    marginTop: 0,
    marginBottom: 0,
  },
  inputField: {
    height: 28,
    padding: 0,
  },
  inputLabel: {
    paddingTop: 0,
    fontSize: theme.headerTextFontSize,
    transform: `translate(14px, 6px) scale(1)`,
    color: theme.iconColor,
  },
});

class ManualDriverAssignment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDriver: null,
      isFeasibleOption: null,
      drivers: []
    };
  }

  componentDidMount() {
    this.setState({
      drivers: this.getDispatchedDriversForManualPickupAssignment()
    });
  }

  getDispatchedDriversForManualPickupAssignment = () => {
    const { recommendationData, dispatchedDrivers } = this.props;
    const driverDetails = recommendationData.map((r) => r.driverRecommendationDetails);
    const feasibleDriversExcludingTop = driverDetails
      .filter((driver) => driver.isFeasibleOption)
      .slice(appConstants.MAX_FEASIBLE_DRIVERS);

    const infeasibleDrivers = driverDetails.filter((driver) => !driver.isFeasibleOption);

    const recommendedDriverIds = driverDetails.map((driver) => driver.driverId?.toLowerCase());
    const nonRecommendedDispatchedDrivers = dispatchedDrivers.filter(
      (driver) => !recommendedDriverIds.includes(driver.driverId?.toLowerCase())
    );

    return [
      ...feasibleDriversExcludingTop,
      ...infeasibleDrivers,
      ...nonRecommendedDispatchedDrivers
    ].map((driver) => ({
      label: `${driver.driverName}`,
      value: driver.driverId,
      labelSuffix: `(${driver.driverNumber})`,
      isFeasibleOption: driver?.isFeasibleOption ?? false
    }));
  };

  handleDriverChange = (option) => {
    const driverId = option ? option.value : null;
    this.setState({
      selectedDriver: driverId,
      isFeasibleOption: option?.isFeasibleOption ?? null
    });
    const selectedDriverRecommendationData = this.getSelectDriverRecommendationData(driverId);
    this.props.handleManualDriverOptionChange(
      selectedDriverRecommendationData,
      option?.isFeasibleOption
    );
    if (driverId) {
      this.props.glEventHub.emit('SelectDriverRoutes', [driverId]);
    }
  };

  getSelectDriverRecommendationData = (driverId) => {
    return (
      this.props.recommendationData.find(
        (r) => r.driverRecommendationDetails.driverId?.toLowerCase() === driverId?.toLowerCase()
      ) ?? { driverRecommendationDetails: { driverId } }
    );
  };

  renderDriverRecommendation() {
    const { classes, isFeasibleDriverCardHighlighted } = this.props;
    const { selectedDriver } = this.state;

    if (!selectedDriver) {
      return null;
    }

    const selectedDriverRecommendationData = this.getSelectDriverRecommendationData(selectedDriver);
    const { driverRecommendationDetails } = selectedDriverRecommendationData;

    if (!driverRecommendationDetails) {
      return <div className={classes.noRecommendations}>KPI details not available</div>;
    }

    return (
      <DriverRecommendationCard
        data={driverRecommendationDetails}
        onClick={() =>
          this.props.handleManualDriverOptionChange(
            selectedDriverRecommendationData,
            driverRecommendationDetails?.isFeasibleOption
          )
        }
        highlightPreviewCard={isFeasibleDriverCardHighlighted(driverRecommendationDetails.driverId)}
        recommendationButtonLabel={constants.RECOMMENDATION_BUTTON_LABEL.PREVIEW}
      />
    );
  }

  render() {
    const { classes } = this.props;
    const { selectedDriver, drivers, isFeasibleOption } = this.state;
    return (
      <div className={classes.container}>
        <div className={classes.label}>Assign Manually</div>
        <div
          className={`${classes.driver} ${
            !isFeasibleOption ? classes.driverInfeasibleContainer : ''
          }`}>
          <span
            className={`${classes.driverNameLabel} ${
              isFeasibleOption ? classes.driverNameLabelMargin : ''
            }`}>
            Driver Name
          </span>
          <div className={classes.dropdownContainer}>
            <Select
              textFieldProps={{
                id: 'customer',
                label: 'Select driver',
                variant: 'outlined',
                helperText: '',
                InputLabelProps: {
                  classes: {
                    root: classes.inputLabel
                  }
                }
              }}
              InputPropsClasses={{
                input: classes.inputField
              }}
              value={selectedDriver}
              onChange={this.handleDriverChange}
              error={Boolean(this.state.errorInfo)}
              data={drivers}
              rootClass={classes.selectRoot}
            />
          </div>
        </div>
        {isFeasibleOption && this.renderDriverRecommendation()}
        {/* KPI will be shown only for feasible driver selected */}
      </div>
    );
  }
}

export default withStyles(styles)(ManualDriverAssignment);